const SingleCardSkeleton = () => {
  return (
    <div className="w-full h-full p-[15px] rounded-[8px] bg-white flex-1 animate-pulse">
      <div>
        {/* Top */}
        <div className="flex justify-between">
          <div className="w-[40px] h-[40px] rounded-full bg-gray-200" />

          <div className="w-[18px] h-[18px] rounded bg-gray-200 mt-1" />
        </div>

        {/* Bottom */}
        <div className="flex items-center justify-between mt-4">
          <div className="flex flex-col gap-2">
            <div className="w-[90px] h-[12px] rounded bg-gray-200" />

            <div className="w-[50px] h-[26px] rounded bg-gray-200" />

            <div className="w-[70px] h-[10px] rounded bg-gray-200" />
          </div>

          <div className="w-[90px] h-[22px] rounded-[10px] bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default SingleCardSkeleton;